module.exports = __webpack_public_path__ + "static/media/01-home.c7e3ba93.png";